export default __webpack_public_path__ + "static/media/038-cat.e015eea4.png";